import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PostService} from '../../../../../services/post.service';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Post} from '../../../../../models/post.model';
import {NameValidator} from '../../../validators/name.validator';
import Swal from 'sweetalert2';
import {ProductService} from '../../../../../services/product.service';
import {Product} from '../../../../../models/product.model';
import {PostProductServiceGiftInfos} from '../../../../../models/postProductServiceGiftInfos.model';

@Component({
  selector: 'app-giftcard-published',
  templateUrl: './giftcard-published.component.html',
  styleUrls: ['./giftcard-published.component.scss']
})
export class GiftcardPublishedComponent implements OnInit {

  shopID: string = '';
  posts: PostProductServiceGiftInfos[] = [];
  postUpdate: Post = {};
  product: Product = {};
  url_photo: string = environment.url_photo;
  @ViewChild('publication') publication;

  updateForm = this.fb.group({
    price: new FormControl('', [ Validators.required,Validators.minLength(3), Validators.maxLength(10), NameValidator.checkOnlyNumberValidator ]),
    description: new FormControl('',[Validators.minLength(18),Validators.maxLength(255)])
  });

  constructor(private route: ActivatedRoute,
              private postService: PostService,
              private productService: ProductService,
              private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
    this.shopID = this.route.snapshot.paramMap.get('shopID');
    this.getPublicationsByShopID();
  }

  getPublicationsByShopID(){
    this.postService.getAllPostProductGiftCardByShopId(this.shopID).subscribe(data => {
      // console.log("#----------------------------------------");
      // console.log(data);
      data.forEach(p => {
        const postInfos = new PostProductServiceGiftInfos();
        postInfos.postId = p.id;
        postInfos.postTitle = p.title;
        postInfos.postCategoryName = p.category.name;
        this.productService.getProductByProductID(p.postProducts[0].productID).subscribe(data => {
          postInfos.postProductPhoto = data.photo;
          postInfos.postProductPrice = data.price;
        });
        postInfos.postPublishedDate = p.publishedAt;
        postInfos.postProductPrice = p.postProducts[0].finalPrice;
        postInfos.postProductID = p.postProducts[0].productID;
        postInfos.postStatusName = p.status.name;
        postInfos.postDescription = p.description;
        this.posts.push(postInfos);
      });
      // console.log("#-----#######################");
      // console.log(this.posts);
    });
  }

  model = {
    description: ''
  };

  get post() { return this.updateForm.controls; }

  updatePublication(p: PostProductServiceGiftInfos) {
    this.postService.getIdPost(p.postId).subscribe(data => {
      this.postUpdate = data;
    })
    this.updateForm.patchValue({
      price: p.postProductPrice,
      description: p.postDescription
    });
  }

  onFormSubmitGiftCard() {
    this.postUpdate.description = this.updateForm.get('description').value;
    this.postUpdate.postProducts[0].price = this.updateForm.get('price').value;
    //this.postUpdate.postProducts[0].product = this.product;

   // console.log(this.postUpdate);

    this.postService.updatePost(this.postUpdate).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Votre annonce a été modifiée avec succès',
        showConfirmButton: false,
        timer: 3500
      });
      this.clear();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  clear() {
    this.updateForm.patchValue({
      price: [],
      description: []
    });
    this.publication.hide();
    this.getPublicationsByShopID();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  disablePost(id: number) {
    this.postService.inactivePost(id).subscribe(data => {
      Swal.fire({
        title: 'Publication désactivée avec succès',
        icon: 'success',
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000
      });
      // this.getPublicationsByShopID();
      this.reloadComponent();
    },error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la désactivation de la publication"',
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

  enablePost(id: number) {
   this.postService.activePost(id).subscribe(data => {
     Swal.fire({
       title: 'Publication activée avec succès',
       icon: 'success',
       position: 'top-end',
       showConfirmButton: false,
       timer: 2000
     });
    //  this.getPublicationsByShopID();
    this.reloadComponent();
   },error => {
     Swal.fire({
       position: 'top-end',
       icon: 'error',
       title: 'Erreur lors de l\'activation de la publication"',
       showConfirmButton: false,
       timer: 2000
     });
   });
  }

  deletePost(post:any){
    //console.log("Id du post à supprimer");
    //console.log(post);
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette annonce ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#00a8bb',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postService.deletePostGiftCard(post).subscribe(
          rs=> {
            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre annonce est supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            window.setTimeout(() => {
              window.location.reload()
            }, 1000);
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur de suppression <br>'+error.error.errorMessage,
              showConfirmButton: false,
              timer: 4500
            })
          }
        )
      }
    })

  }
}
